/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactUploadRequest } from './ContactUploadRequest.js';
import {
    ContactUploadRequestFromJSON,
    ContactUploadRequestFromJSONTyped,
    ContactUploadRequestToJSON,
} from './ContactUploadRequest.js';

/**
 * 
 * @export
 * @interface CreateScorecardRequest
 */
export interface CreateScorecardRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateScorecardRequest
     */
    customerExternalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateScorecardRequest
     */
    eventDate?: Date;
    /**
     * 
     * @type {Array<ContactUploadRequest>}
     * @memberof CreateScorecardRequest
     */
    contacts?: Array<ContactUploadRequest>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateScorecardRequest
     */
    properties?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CreateScorecardRequest interface.
 */
export function instanceOfCreateScorecardRequest(value: object): boolean {
    return true;
}

export function CreateScorecardRequestFromJSON(json: any): CreateScorecardRequest {
    return CreateScorecardRequestFromJSONTyped(json, false);
}

export function CreateScorecardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScorecardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customerExternalId': json['customerExternalId'] == null ? undefined : json['customerExternalId'],
        'eventDate': json['eventDate'] == null ? undefined : (new Date(json['eventDate'])),
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(ContactUploadRequestFromJSON)),
        'properties': json['properties'] == null ? undefined : json['properties'],
    };
}

export function CreateScorecardRequestToJSON(value?: CreateScorecardRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customerExternalId': value['customerExternalId'],
        'eventDate': value['eventDate'] == null ? undefined : ((value['eventDate'] as any).toISOString()),
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(ContactUploadRequestToJSON)),
        'properties': value['properties'],
    };
}

